var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.5c0 4.136-3.364 7.5-7.5 7.5S1 13.636 1 9.5c0-3.498 2.476-6.579 5.888-7.326l.214.977C4.146 3.798 2 6.468 2 9.5 2 13.084 4.916 16 8.5 16S15 13.084 15 9.5c0-3.028-2.143-5.698-5.096-6.348l.215-.977C13.527 2.926 16 6.006 16 9.5M9 0H8v10h1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/off.svg";